"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketLifecycleInput_1 = require("./PutBucketLifecycleInput");
var PutBucketLifecycleOutput_1 = require("./PutBucketLifecycleOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketLifecycle = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketLifecycle",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?lifecycle"
    },
    input: {
        shape: PutBucketLifecycleInput_1.PutBucketLifecycleInput
    },
    output: {
        shape: PutBucketLifecycleOutput_1.PutBucketLifecycleOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketLifecycle.js.map